import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface ConflictResolutionDialogProps {
  open: boolean;
  isResolving: boolean;
  onReloadRemote: () => void;
  onPreserveVariant: () => Promise<void>;
}

export function ConflictResolutionDialog({
  open,
  isResolving,
  onReloadRemote,
  onPreserveVariant,
}: ConflictResolutionDialogProps) {
  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>Another collaborator saved this document</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your unsaved draft is still safe in this tab. Reload the collaborator&apos;s latest version and discard your draft, or preserve your draft as a separate variant. Creating a variant will not make it the main version.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onReloadRemote} color="error" disabled={isResolving}>
          Discard local and reload
        </Button>
        <Button onClick={() => void onPreserveVariant()} variant="contained" disabled={isResolving}>
          {isResolving ? 'Saving variant…' : 'Preserve as variant'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}